import { Phone, WhatsappLogo } from '@phosphor-icons/react';

// Nettoie un numéro pour wa.me : garde uniquement les chiffres.
const toWaNumber = (raw) => (raw || '').replace(/[^0-9]/g, '');

/**
 * Boutons rapides Appel + WhatsApp pour un numéro donné.
 * @param {string} phone - numéro de téléphone (format libre, ex "+243 812 345 678")
 * @param {string} name  - nom affiché dans le testid (optionnel)
 * @param {'sm'|'xs'} size
 */
const ContactActions = ({ phone, name = '', size = 'sm' }) => {
  if (!phone) return null;
  const wa = toWaNumber(phone);
  const cls = size === 'xs' ? 'h-7 w-7' : 'h-8 w-8';
  const icon = size === 'xs' ? 13 : 15;
  const stop = (e) => e.stopPropagation();
  const id = (name || phone).toString().toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="flex items-center gap-1">
      <a
        href={`tel:${phone.replace(/\s/g, '')}`}
        onClick={stop}
        className={`${cls} inline-flex items-center justify-center rounded-md text-[#10B981] hover:text-white hover:bg-[#10B981] transition-colors`}
        title="Appeler"
        data-testid={`call-${id}`}
      >
        <Phone size={icon} weight="bold" />
      </a>
      {wa && (
        <a
          href={`https://wa.me/${wa}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={stop}
          className={`${cls} inline-flex items-center justify-center rounded-md text-[#25D366] hover:text-white hover:bg-[#25D366] transition-colors`}
          title="WhatsApp"
          data-testid={`whatsapp-${id}`}
        >
          <WhatsappLogo size={icon} weight="bold" />
        </a>
      )}
    </div>
  );
};

export default ContactActions;
